import { CountryCode } from '@carsys/enums/country-code'
import { OrderSystem } from '@cbgms/api'

export const wholesalerOrderSystemKey = (country: CountryCode, orderSystem: OrderSystem) => ['SUPPORT', 'WHOLESALER', country, orderSystem]

export const wholesalerWithServiceKey = (UUID: string, country?: CountryCode, orderSystem?: OrderSystem) => [
  'SUPPORT',
  'WHOLESALER',
  country,
  orderSystem,
  UUID
]

export const wholesalerCatalogsCacheKey = (wholesalerUUID: string) => ['SUPPORT', 'WHOLESALER', wholesalerUUID, 'CATALOG']

export const externalPortalsCacheKey = () => ['EXTERNAL_PORTALS']
